<template>
       <span>
           <tippani-header subject="Application for visa plan upgrade"/>
           <p>
               I would like to request to you to upgrade my visa plan form {{table_data.previous_plan}} to {{table_data.new_plan}}.
               Upgrade fee and other related documents are attached here within
           </p>
           <div>
                  <table style="width: 100%;">
                <tr>
                    <td>Submission Id:</td>
                    <td>{{table_data.submission_no}}</td>
                </tr>
                <tr>
                    <td>Visa number:</td>
                    <td>{{table_data.visa_number}}</td>
                </tr>
                <tr>
                    <td>Expiry date:</td>
                    <td>{{table_data.expiry_date}}</td>
                </tr>
                <tr>
                    <td>Full name</td>
                    <td>{{table_data.full_name}}</td>
                </tr>
                <tr>
                    <td>Passport Number:</td>
                    <td>{{table_data.passport_number}}</td>
                </tr>
                <tr>
                    <td>Transfer cost ($):</td>
                    <td>
                        {{table_data.update_cost}}
                    </td>
                </tr>
                <tr v-if="data.voucher_number">
                    <td>Voucher number:</td>
                    <td>
                        {{data.voucher_number}}
                    </td>
                </tr>
            </table>
           </div>
           <div v-html="content"></div>
       <div style="margin-top: 20px;">
            Prepared by : <b>{{created_by}} </b>
        </div>
    </span>
</template>

<script>
    import TippaniHeader from "./TippaniHeader";

    export default {
        name: "PlanTippaniPrint",
        computed: {
            table_data() {
                const {visa, plan_data, submission_no,traveller} = this.$store.state.PlanUpgrade.upgrade_data;
                const previous_plan = visa.plan;
                const new_plan = plan_data.new_plan;
                return {
                    previous_plan,
                    new_plan,
                    submission_no,
                    visa_number: visa.visa_number,
                    expiry_date:visa.expiry_date,
                    full_name:traveller.name,
                    passport_number:visa.passport_number,
                    update_cost:plan_data.cost
                }
            },
            content() {
                if (this.$store.state.PlanUpgrade.upgrade_data.tippani_content)
                    return this.$store.state.PlanUpgrade.upgrade_data.tippani_content;

                return this.$store.state.PlanUpgrade.tippaniContent;
            },
            data() {
                return this.$store.state.Transfer.transferDetail;
            },
            created_by() {
                let roles = this.$store.state.AuthUser.user.roles;
                roles = roles[0];
                return this.$store.state.AuthUser.user.full_name + ' (' + roles.display_name + ')';
            }
        },
        components: {
            TippaniHeader
        }
    }
</script>

<style scoped>
    table, th, td {
        border: 1px solid black;
    }

    table {
        border-collapse: separate;
        border-spacing: 1px;
        border-left: 0;
        border-bottom: 0;
    }

    td, th {
        border-top: 0;
        border-right: 0;
        padding: 5px;
    }
</style>
